
import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';
import { useUser } from '../context/UserContext';

const Billing = () => {
  const { orders } = useCart();
  const { authFetch } = useUser();  // ✅ Используем авторизованный запрос
  const now = new Date();
  const [monthOffset, setMonthOffset] = useState(0);
  const [budgetInfo, setBudgetInfo] = useState(null);

  const startOfMonth = new Date(now.getFullYear(), now.getMonth() - monthOffset, 1);
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() - monthOffset + 1, 0);

  const monthLabel = startOfMonth.toLocaleString('ru-RU', {
    month: 'long',
    year: 'numeric'
  }).replace(/^./, str => str.toUpperCase());

  const year = startOfMonth.getFullYear();
  const month = startOfMonth.getMonth() + 1;

  const currentMonthOrders = orders.filter(order => {
    const date = new Date(order.createdAt);
    return date >= startOfMonth && date <= endOfMonth;
  });

  useEffect(() => {
    const url = `/company-budget/${year}-${String(month).padStart(2, '0')}`;
    console.log('📡 Запрос бюджета:', url);
  
    authFetch(url)
      .then(data => {
        console.log('📦 Бюджет:', data);
        setBudgetInfo(data);
      })
      .catch(err => {
        console.error('❌ Ошибка бюджета:', err);
        setBudgetInfo(null);
      });
  }, [authFetch, monthOffset, year, month]);
  

  return (
    <div className="text-white p-6 max-w-4xl mx-auto space-y-6">
      <div className="bg-gray-800 rounded-xl p-6 shadow-md flex items-center justify-between">
        <h1 className="text-2xl font-bold">💳 Счета за {monthLabel}</h1>
        <div className="space-x-2">
          <button
            onClick={() => setMonthOffset(prev => prev + 1)}
            className="bg-gray-700 hover:bg-gray-600 text-sm px-3 py-1 rounded"
          >
            ← Назад
          </button>
          {monthOffset > 0 && (
            <button
              onClick={() => setMonthOffset(prev => prev - 1)}
              className="bg-gray-700 hover:bg-gray-600 text-sm px-3 py-1 rounded"
            >
              Вперёд →
            </button>
          )}
        </div>
      </div>

      <div className="bg-gray-900 rounded-xl p-6 shadow space-y-4">
        <h2 className="text-lg font-semibold">Финансовая сводка:</h2>
        <p className="text-md">
          💰 Доступный бюджет:{' '}
          <span className="text-green-400 font-bold">
            {budgetInfo?.totalBudget != null ? budgetInfo.totalBudget.toLocaleString() : 'Загрузка...'} ₽
          </span>
        </p>
        <p className="text-md">
          📉 Потрачено:{' '}
          <span className="text-yellow-400 font-bold">
            {budgetInfo?.spent != null ? budgetInfo.spent.toLocaleString() : 'Загрузка...'} ₽
          </span>
        </p>
        <p className="text-md">
          💼 Остаток:{' '}
          <span className="text-blue-400 font-bold">
            {budgetInfo?.remaining != null
              ? (budgetInfo.remaining < 0 ? 0 : budgetInfo.remaining).toLocaleString()
              : 'Загрузка...'} ₽
          </span>
        </p>
        <p className="text-sm text-gray-400">Всего заказов: {currentMonthOrders.length}</p>
      </div>

      <div className="bg-gray-800 rounded-xl p-6 shadow">
        <h2 className="text-lg font-semibold mb-4">Заказы за месяц:</h2>
        {currentMonthOrders.length === 0 ? (
          <p className="text-gray-400 text-sm">Нет заказов за выбранный месяц.</p>
        ) : (
          <ul className="divide-y divide-gray-700">
            {currentMonthOrders.map(order => (
              <li key={order.id} className="py-3 text-sm flex justify-between">
                <span>{new Date(order.createdAt).toLocaleDateString('ru-RU')}</span>
                <span className="text-green-300 font-semibold">{order.total.toLocaleString()} ₽</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Billing;
